export default {
    Header: {
        Search: "搜索",
        Home: "主页",
        Album: "图集",
        About: "关于",
        Link: "友链",
        TimeList: "时间轴",
        Mark: {
            Mail: "点击给我发送邮件",
            GitHub: "点击进入我的GitHub页面",
            QQ: "点击添加我的QQ",
            WeChat: "点击添加我的微信"
        }
    },
    Slider: {
        Language: {
            Content: "",
            Title: "Switch language to English"
        }
    },
    Notice: {
        Language: "切换语言成功！"
    },
    Other: {
        Maintain: "剩余内容正在维护中！"
    },
    Music: {
        Title: "音乐栏",
        Album: "专辑图片",
        LastMusic: "上一首",
        PlayMusic: "播放/暂停音乐",
        NextMusic: "下一首",
        MusicList: "展开/缩放音乐页",
        SwitchMusic: "切换音乐"
    },
    Writing: {
        Title: "发布文章",
    },
    About: {
        Title: "关于 | 王基书",
        Update: "最近更新：",
        News: {
            Title: "科研动态",
            Content: [
                {
                    Title: "一作论文被<b style='color: indianred'>IEEE Transactions on Cloud Computing</b>录用！",
                    Date: "2026年3月22日"
                },
                {
                    Title: "一作论文被<b style='color: indianred'>IEEE Transactions on Intelligent Transportation Systems</b>录用！",
                    Date: "2025年5月25日"
                },
                {
                    Title: "入选首批<b style='color: indianred'>中国科协青年人才托举工程博士生专项计划</b>，托举学会为<b style='color: indianred'>中国汽车工程学会</b>！",
                    Date: "2025年1月9日"
                },
                // {
                //     Title: "获得中国高校计算机大赛-网络技术挑战赛的<b style='color: indianred'>西南赛区二等奖</b>！",
                //     Date: "2024年6月27日"
                // }, {
                //     Title: "获得中国大学生服务外包创新创业大赛<b style='color: indianred'>中部区域赛三等奖</b>！",
                //     Date: "2024年5月21日"
                // },
                {
                    Title: "一作论文被<b style='color: indianred'>IEEE Transactions on Network and Service Management</b>录用！",
                    Date: "2023年12月23日"
                },
                // {
                //     Title: "获得中国高校计算机大赛-网络技术挑战赛的<b style='color: indianred'>全国三等奖</b>！",
                //     Date: "2023年9月1日"
                // },
                // {
                //     Title: "获得中国高校计算机大赛-网络技术挑战赛的<b style='color: indianred'>西南赛区二等奖（进入国赛）</b>！",
                //     Date: "2023年6月27日"
                // },
                // {
                //     Title: "获得中国大学生服务外包创新创业大赛<b style='color: indianred'>中部区域赛三等奖</b>！",
                //     Date: "2023年5月18日"
                // },
                {
                    Title: "一作论文被<b style='color: indianred'>IEEE Transactions on Intelligent Transportation Systems</b>录用！",
                    Date: "2022年11月7日"
                },
                {
                    Title: "云大科研创新项目获<b style='color: indianred'>主持立项</b>！",
                    Date: "2022年10月18日"
                },
                {
                    Title: "一作论文被<b style='color: indianred'>IEEE Transactions on Vehicular Technology</b>录用！",
                    Date: "2021年9月14日"
                }
            ],
        },
        Blog: {
            Title: "博客",
            Content:
            // "<p>小站使用Vue.js框架搭建而成，为了提升自己的前端能力，未直接使用ElementUI等UI库，而是自行开发。界面在不断迭代更新中，目前已是第4个大的版本（Vue.js）。</p>" +
            // "<p>界面在不断迭代更新中，目前已是第4个大的版本（Vue.js），具体过程请移步<router-link to='/TimeList' style='color: limegreen;border-bottom: 2px solid limegreen'>时间轴</router-link>。当前正在完善第4个版本，最终完全使用Vue实现数据绑定的多组件，进一步提升体验，敬请期待。</p>" +
            // "<p>声明：所有文章（代码）均为原创。小站遵循“(CC BY 4.0)”创作共享协议。</p>" +
            // "<p>会一直更新：</p>" +
            // "<p style='text-indent: 2em;'>1) 竞赛：蓝桥杯、服创大赛、网络技术挑战赛</p>" +
            // "<p style='text-indent: 2em;'>2) 经历：论文、会议</p>" +
            // "<p style='text-indent: 2em;'>3) 研究生：硕士、博士</p>" +
            // "<p style='text-indent: 2em;'>4) 说&分享：项目</p>" +
                "<p>当前主要研究方向为<b>区块链</b>（可扩展性优化、停车系统与智能体行为监管等关键场景中的解决方案）与<b>智能交通系统</b>（停车效率与服务优化），在具体研究过程中还涉及到机器学习与计算机视觉等领域。以第一/通讯作者在<b>IEEE Transactions汇刊</b>在内的高水平期刊/会议共发表论文<b>5</b>篇，包括<b style='color: red'>TITS（2篇）、TCC（1篇）、TVT（1篇）、TNSM（1篇）</b>，此外共合作发表文章<b>14</b>篇。入选<b>首批中国科协青托博士生专项</b>，主持云南省教育厅、云南大学科研项目<b>2</b>项；第一排名授权发明专利<b>1</b>项和软件著作权<b>3</b>项；获学科专业/创新创业类竞赛奖项<b>24</b>项及研究生国家奖学金（硕博阶段各一次）、省政府奖学金、熊庆来奖学金等荣誉<b>20</b>项；受邀担任IEEE TSC、IEEE TNSM、IEEE IoTJ等高水平期刊审稿人。" +
                "<p style=' font-weight: bold;color: salmon'>欢迎对研究方向感兴趣，且具有强烈自驱力（如读博意向）的同学邮件联系，我推崇通过科学研究（论文）+专业竞赛（实践）的方式来培养学生，并竭尽所能地给予指导，最终希望你能够真正学到有用的知识并加以运用。我们将共同成长。 </p>"
            // "<p>当前主要研究方向为<b>区块链</b>与<b>智能交通系统</b>。在<b style='color: red'>IEEE Transactions on Intelligent Transportation Systems</b>、<b style='color: red'>IEEE Transactions on Vehicular Technology</b>、<b style='color: red'>IEEE Transactions on Network and Service Management</b>等顶级期刊发表一作论文<b>3</b>篇，在<b>IEEE TKDE、IEEE TCSS、IEEE TNSM、IEEE IoTJ</b>等期刊以及<b>SANER</b>等会议合作发表文章<b>10</b>篇，在<b>PPNA、TJSC</b>等SCI期刊和会议担任审稿人。以第一排名身份主持科研项目<b>2</b>项、授权发明专利<b>1</b>项、获软件著作权<b>3</b>项，获学科专业（创新创业）类竞赛奖项<b>24</b>项及研究生国家奖学金、熊庆来奖学金等荣誉<b>19</b>项。</p>"
        },
        Introduction: {
            Title: "介绍",
            Name: "王基书",
            Career: "<b style='color: #0E90D2'>背景经历<b/>",
            Undergraduate: "<p><b>2015.09 —— 2019.06</b>，<b>昆明学院</b>，信息工程学院，计算机科学与技术，本科</p>",
            Graduate: "<p><b>2019.08 —— 2022.06</b>，<b>云南大学</b>，国家示范性软件学院，软件工程，专业型硕士研究生<sup style='color: red;font-weight: bolder;'>（导师：李彤教授）</sup></p>",
            GraduateSupervisor: "",
            PhD: "<p><b>2022.09 —— 2026.06</b>，<b>云南大学</b>，信息学院，计算机科学与技术，学术型博士研究生<sup style='color: red;font-weight: bolder;'>（导师：张璇教授）</sup></p>",
            PhDSupervisor: "",
            Lecture:"<p><b>2026.09 —— 20xx.xx</b>，<b>云南师范大学</b>，信息学院，讲师</p>"
        },
        Publications: {
            Publications: "论文",
            TotalCites: "累计引用",
            CCF: "CCF A+B+C（一作+合著）",
            WoS: "WoS",
            DBLP: "DBLP",
            ResearchGate: "ResearchGate",
            ORCID: "ORCID",
            FirstAuthor: "第一作者",
            Trans: "IEEE Trans.（一作+合著）",
            CoAuthor: "合著作者",
            HighestIF: "单篇最高IF（一作）",
            HighestCite: "单篇最高引用（一作）",
            HIndex: "H-Index",
            I10Index: "I10-Index",
            Tips: "注：论文所标明的出版物的<a href='https://advanced.fenqubiao.com/' target='_blank' style='color:#ff8d02;font-weight: bolder'>中科院分区</a>、<a href='https://jcr.clarivate.com/jcr/home' target='_blank' style='color:#34cd34;font-weight: bolder'><b style='color:#ff8d02;'>JCR分区</b>、影响因子（IF）</a>以及<a href='https://www.ccf.org.cn/Academic_Evaluation/By_category/' target='_blank' style='color:mediumpurple;font-weight: bolder'>CCF分级</a>均采用该篇论文正式发表（即拥有卷、期号）时的数据。 </br>因此，即使多篇论文发表于同一期刊，其数据也可能存在差异（如不同的分区和IF）。",
            TopJournal: "国际顶级期刊",
            IF: "影响因子",
            Reviewing: "审稿中",
            Accepted: "已接收",
            Article: "已发表",
            ID: "序号",
            MainTitle: "论文",
            Title: "标题",
            Authors: "作者",
            Journal: "期刊/会议",
            Update: "2026.09.19",
            Count: {
                Trans: "5+3",
                CCF: "1+4+7",
                TotalCite: 261,
                HighestCite: 33,
                HighestIF: 9.551,
                HIndex: 7,
                I10Index: 6,
            },
            First: [
                {
                    Year: 2026,
                    Date: "2026.04",
                    Title: "BPO-CBS: A Data-Driven Blockchain Performance Optimization Framework for Cloud Blockchain Services",
                    Authors: "<b style='color: red'>Jishu Wang</b>, Xuan Zhang<sup>*</sup>, Linfeng Liu, Xuekun Yang, Tao Zhou, Chen Miao, Rui Zhu, Zhi Jin",
                    Journal: "IEEE Transactions on Cloud Computing (TCC)",
                    Level: "SCI",
                    Area: "中科院2区",
                    JCR: "JCR Q1",
                    CCF: "CCF-B",
                    IF: "IF: 5",
                    TOP: "",
                    Cite: "0",
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/11455975"
                },
                {
                    Year: 2025,
                    Date: "2025.08",
                    Title: "PRPSV: Parking Efficiency and Reservation Service Optimization Based on Parking Space View",
                    Authors: "<b style='color: red'>Jishu Wang</b>, Yaowei Wang, Xuan Zhang<sup>*</sup>, Linyu Li, Xue Wang, Shenglong Lv, Rui Zhu, Tong Li",
                    Journal: "IEEE Transactions on Intelligent Transportation Systems (TITS)",
                    Level: "SCI",
                    Area: "中科院2区",
                    JCR: "JCR Q1",
                    CCF: "CCF-B",
                    IF: "IF: 8.4",
                    TOP: "Top",
                    Cite: 2,
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/11029612"
                },
                {
                    Year: 2024,
                    Date: "2024.04",
                    Title: "LearningChain: A Highly Scalable and Applicable Learning-Based Blockchain Performance Optimization Framework",
                    Authors: "<b style='color: red'>Jishu Wang</b>, Yaowei Wang, <b>Xuan Zhang</b><sup>*</sup>, Zhi Jin, Chao Zhu, Linyu Li, Rui Zhu, Shenglong Lv",
                    Journal: "IEEE Transactions on Network and Service Management (TNSM)",
                    Level: "SCI",
                    Area: "中科院2区",
                    JCR: "JCR Q2",
                    CCF: "CCF-C",
                    IF: "IF: 5.3",
                    TOP: "",
                    Cite: 20,
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/10375789"
                },
                {
                    Year: 2023,
                    Date: "2023.03",
                    Title: "BPR: Blockchain-Enabled Efficient and Secure Parking Reservation Framework with Block Size Dynamic Adjustment Method",
                    Authors: "<b style='color: red'>Jishu Wang</b>, Chao Zhu, Chen Miao, Rui Zhu<sup>*</sup>, Xuan Zhang<sup>*</sup>, Yahui Tang, Hexiang Huang, Chen Gao",
                    Journal: "IEEE Transactions on Intelligent Transportation Systems (TITS)",
                    Level: "SCI",
                    Area: "中科院1区",
                    JCR: "JCR Q1",
                    CCF: "CCF-B",
                    IF: "IF: 9.551",
                    TOP: "Top",
                    Cite: 25,
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/9961087"
                }, {
                    Year: 2021,
                    Date: "2021.11",
                    Title: "ETC-Oriented Efficient and Secure Blockchain: Credit-Based Mechanism and Evidence Framework for Vehicle Management",
                    Authors: "<b style='color: red'>Jishu Wang</b>, Rui Zhu<sup>*</sup>, Tong Li, Fengsen Gao, Qiang Wang, Qiang Xiao",
                    Journal: "IEEE Transactions on Vehicular Technology (TVT)",
                    Level: "SCI",
                    Area: "中科院2区",
                    JCR: "JCR Q1",
                    CCF: "",
                    IF: "IF: 5.978",
                    TOP: "Top",
                    Cite: 33,
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/9552488"
                }],
            Co: [
                {
                    Year: 2027,
                    Date: "2027.01",
                    Title: "Diffusion sequential recommendation model based on item co-occurrence anchoring and user semantic collaboration",
                    Authors: "Shaoheng Xie, Xuan Zhang<sup>*</sup>, Kunpeng Du, <b style='color: red'>Jishu Wang<sup>4th</sup></b>, Xiaopeng Li, Junda Li, Weiyi Shang, Zhi Jin",
                    Journal: "Expert Systems with Applications (ESWA)",
                    Level: "SCI",
                    Area: "中科院1区",
                    JCR: "JCR Q1",
                    CCF: "CCF-C",
                    IF: "IF: 9.4",
                    TOP: "Top",
                    Cite: 0,
                    State: "Article",
                    Link: "https://doi.org/10.1016/j.eswa.2026.133431"
                },
                {
                    Year: 2026,
                    Date: "2026.06",
                    Title: "基于二阶多通道有向图卷积的基因调控推断方法",
                    Authors: "沈亚婕，<b style='color: red'>王基书<sup>2nd</sup></b>，金魁，字桐，唐明靖",
                    Journal: "计算机科学",
                    Level: "中文核心",
                    Area: "",
                    JCR: "",
                    CCF: "CCF-T2",
                    IF: "",
                    TOP: "",
                    Cite: 0,
                    State: "Article",
                    Link: "https://kns.cnki.net/kcms2/article/abstract?v=jit-Bskw5eTbqkHnoF63Lds25rWsuB2AkY7n1dwDW5W8Q5gg0PjotTANkNPdIEqv6fRLIKU1wjQOti5h65HSBPFeJFWst3DvHPP0RorG4sqfOkE4tZVpO8PB2zA1LqfLz-2WR6DmTUYoBwFCBX4J7my-2m1GijlxkI-kk2ZiowT0pyvglXs1AA==&uniplatform=NZKPT&language=CHS"
                },
                {
                    Year: 2026,
                    Date: "2026.04",
                    Title: "面向工业物联网基于区块链的高效安全联邦学习框架",
                    Authors: "何腾远，<b style='color: red'>王基书<sup>共同一作</sup></b>，王敏，唐明靖",
                    Journal: "山东大学学报（工学版）",
                    Level: "中文核心",
                    Area: "",
                    JCR: "",
                    CCF: "",
                    IF: "",
                    TOP: "",
                    Cite: 0,
                    State: "Article",
                    Link: "https://kns.cnki.net/kcms2/article/abstract?v=jit-Bskw5eTYwoTECxvW6qIpQ_8StP3UR2aarhP68Y8qk4Pivaal2GnyOw9vdbyu9UcGYf7NZI42w1sUTW6B9xhR315N64-flHSsgGxsVKFVTIoJMO3JEdPqKQwqfi2wtJXaHxf9LQWYGwguyI74-dGohn6MZ8IRGzqLyg-JKTSoqRryYbKVNw==&uniplatform=NZKPT&language=CHS"
                },
                {
                    Year: 2026,
                    Date: "2026.03",
                    Title: "A bi-level planning framework for solving multi-task schedule path planning problem in mountain orchard",
                    Authors: "Tao Zhou, Xuan Zhang<sup>*</sup>, <b style='color: red'>Jishu Wang<sup>3rd</sup></b>, Linfeng Liu, Jianping Yang, Linyu Li, Tong Li",
                    Journal: "Computers and Electronics in Agriculture (COMPAG)",
                    Level: "SCI",
                    Area: "中科院1区",
                    JCR: "JCR Q1",
                    CCF: "",
                    IF: "IF: 8.9",
                    TOP: "Top",
                    Cite: 0,
                    State: "Article",
                    Link: "https://www.sciencedirect.com/science/article/pii/S0168169926000554?via%3Dihub"
                },
                {
                    Year: 2025,
                    Date: "2025.06",
                    Type: "Non-First",
                    Title: "BTDS: Blockchain-Enabled Trusted Vehicle Violation Detection by Self-Supervision",
                    Authors: "Rui Zhu, Shengnan Hu, Sumi Helal, Junqiao Song, <b style='color: red'>Jishu Wang<sup>5th</sup></b>, Yeting Chen<sup>*</sup>",
                    Journal: "IEEE Internet of Things Journal (IoTJ)",
                    Level: "SCI",
                    Area: "中科院2区",
                    JCR: "JCR Q1",
                    CCF: "CCF-C",
                    IF: "IF: 8.9",
                    TOP: "Top",
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/10891140"
                },
                {
                    Year: 2025,
                    Date: "2025.06",
                    Type: "Non-First",
                    Title: "RMCT: Distributed electricity transaction based on reputation mechanism and multi-chain technology in blockchain environment",
                    Authors: "Shenglong Lv, Xuan Zhang<sup>*</sup>, <b style='color: red'>Jishu Wang<sup>3rd</sup></b>, Weidong Xiong, Li Yang",
                    Journal: "Electric Power Systems Research (EPSR)",
                    Level: "SCI",
                    Area: "中科院3区",
                    JCR: "JCR Q2",
                    CCF: "",
                    IF: "IF: 3.3",
                    TOP: "",
                    State: "Article",
                    Link: "https://www.sciencedirect.com/science/article/pii/S0378779625001087"
                }, {
                    Year: 2025,
                    Date: "2025.05",
                    Type: "Non-First",
                    Title: "Multi-View Riemannian Manifolds Fusion Enhancement for Knowledge Graph Completion",
                    Authors: "Linyu Li, Zhi Jin<sup>*</sup>, Xuan Zhang, Haoruan Duan, <b style='color: red'>Jishu Wang<sup>5th</sup></b>, Zhengwei Tao, Haiyan Zhao, Xiaofeng Zhu",
                    Journal: "IEEE Transactions on Knowledge and Data Engineering (TKDE)",
                    Level: "SCI",
                    Area: "中科院1区",
                    JCR: "JCR Q1",
                    CCF: "CCF-A",
                    IF: "IF: 8.9",
                    TOP: "Top",
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/10884893"
                },
                {
                    Year: 2025,
                    Date: "2025.04",
                    Type: "Non-First",
                    Title: "RLChain: A DRL Approach for Blockchain Performance Optimization Towards IIoT",
                    Authors: "Min An, Xuan Zhang<sup>*</sup>, <b style='color: red'>Jishu Wang<sup>3rd</sup></b>, Qiyuan Fan, Chen Gao, Linyu Li, Cuizhen Lu, Nan Li, Yingchen Liu",
                    Journal: "IEEE Transactions on Network and Service Management (TNSM)",
                    Level: "SCI",
                    Area: "中科院2区",
                    JCR: "JCR Q1",
                    CCF: "CCF-C",
                    IF: "IF: 4.7",
                    TOP: "",
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/10753495"
                }, {
                    Year: 2024,
                    Date: "2024.06",
                    Type: "Non-First",
                    Title: "PEAE-GNN: Phishing Detection on Ethereum via Augmentation Ego-Graph based on Graph Neural Network",
                    Authors: "Hexiang Huang, Xuan Zhang<sup>*</sup>, <b style='color: red'>Jishu Wang<sup>3rd</sup></b>, Chen Gao, Xue Li, Rui Zhu, Qiuying Ma",
                    Journal: "IEEE Transactions on Computational Social Systems (TCSS)",
                    Level: "SCI",
                    Area: "中科院2区",
                    JCR: "JCR Q1",
                    CCF: "CCF-C",
                    IF: "IF: 5",
                    TOP: "",
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/10410420/"
                },
                {
                    Year: 2023,
                    Date: "2023.09",
                    Type: "Non-First",
                    Title: "Fine-grained cybersecurity entity typing based on multimodal representation learning",
                    Authors: "Baolei Wang, Xuan Zhang<sup>*</sup>, <b style='color: red'>Jishu Wang<sup>3rd</sup></b>, Chen Gao, Qing Duan, Linyu Li",
                    Journal: "Multimedia Tools and Applications (MTA)",
                    Level: "SCI",
                    Area: "中科院4区",
                    JCR: "JCR Q2",
                    CCF: "CCF-C",
                    IF: "IF: 3.6",
                    TOP: "",
                    State: "Article",
                    Link: "https://link.springer.com/article/10.1007/s11042-023-16839-z"
                },
                {
                    Year: 2023,
                    Date: "2023.05",
                    Type: "Non-First",
                    Title: "ASTHGCN: Adaptive Spatio-Temporal Hypergraph Convolutional Network for Traffic Forecasting",
                    Authors: "Chao Zhu, Jing Chen, Rui Zhu<sup>*</sup>, Zhengqiong Wang, Shihan Liu, <b style='color: red'>Jishu Wang<sup>6th</sup></b>",
                    Journal: "IEEE International Conference on Software Analysis, Evolution and Reengineering (SANER) <sup>30th</sup>, Workshop",
                    Level: "EI",
                    Area: "",
                    JCR: "",
                    CCF: "CCF-B",
                    IF: "",
                    TOP: "",
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/10123444/"
                }, {
                    Year: 2022,
                    Date: "2022.11",
                    Type: "Non-First",
                    Title: "A Knowledge Graph Completion Model Based on Contrastive Learning and Relation Enhancement Method",
                    Authors: "Linyu Li, Xuan Zhang<sup>*</sup>, Yubin Ma, Chen Gao, <b style='color: red'>Jishu Wang<sup>5th</sup></b>, Yong Yu, Zihao Yuan, Qiuying Ma",
                    Journal: "Knowledge-Based Systems (KBS)",
                    Level: "SCI",
                    Area: "中科院1区",
                    JCR: "JCR Q1",
                    CCF: "CCF-C",
                    IF: "IF: 8.139",
                    TOP: "Top",
                    State: "Article",
                    Link: "https://www.sciencedirect.com/science/article/pii/S0950705122009820"
                },
                {
                    Year: 2021,
                    Date: "2021.08",
                    Type: "Non-First",
                    Title: "A Discovery Method for Hierarchical Software Execution Behavior Models Based on Components",
                    Authors: "Yahui Tang, Tong Li<sup>*</sup>, Rui Zhu<sup>*</sup>, Fei Du, <b style='color: red'>Jishu Wang<sup>5th</sup></b>, Zifei Ma",
                    Journal: "Scientific Programming",
                    Level: "SCI",
                    Area: "中科院4区",
                    JCR: "JCR Q4",
                    CCF: "",
                    IF: "IF: 1.025",
                    TOP: "",
                    State: "Article",
                    Link: "https://www.hindawi.com/journals/sp/2021/4788357/"
                },
                {
                    Year: 2021,
                    Date: "2021.08",
                    Type: "Non-First",
                    Title: "基于完全前缀展开的业务过程模型结构化简与行为保持方法",
                    Authors: "黄月，朱锐<sup>*</sup>，李彤，<b style='color: red'>王基书<sup>4th</sup></b>，汤雅惠，吕昌龙",
                    Journal: "计算机集成制造系统",
                    Level: "EI",
                    Area: "",
                    JCR: "",
                    CCF: "CCF-T3",
                    IF: "",
                    TOP: "",
                    State: "Article",
                    Link: "https://kns.cnki.net/kcms/detail/detail.aspx?dbcode=CAPJ&dbname=CAPJLAST&filename=JSJJ20210617001&uniplatform=NZKPT&v=EfDktvpY4SBHT571nclF6i5DxZhFMRWSkp6U5FuaPiHIJub4oLa2rwD%25mmd2F2hahj%25mmd2BP5"
                }]
        },
        Competitions: {
            Title: "竞赛获奖 (省级及以上）",
            Undergraduate: {
                Title: "本科",
                Content: [{
                    Name: " 第8届蓝桥杯大赛，",
                    Level: "云南省三等奖（个人赛，Java大学B组），",
                    Date: "2017年4月。",
                },]
            },
            Graduate: {
                Title: "硕士研究生",
                Content: [{
                    Name: " 第11届中国大学生服务外包创新创业大赛，",
                    Level: "中部区域赛三等奖（<b style='color: red'>队长</b>，赛题A06，交通流量预测相关），",
                    Date: "2020年5月。"
                }, {
                    Name: " 第5届中国高校计算机大赛-网络技术挑战赛，",
                    Level: "西南赛区二等奖（成员，赛题A，无人机、图像识别相关），",
                    Date: "2020年7月。"
                }, {
                    Name: " 第5届中国高校计算机大赛-网络技术挑战赛，",
                    Level: "全国三等奖（成员，赛题A，无人机、图像识别相关），",
                    Date: "2020年10月。"
                }, {
                    Name: " 第11届蓝桥杯大赛，",
                    Level: "<b style='color: red'>云南省一等奖</b>（个人赛，Python大学组），",
                    Date: " 2020年10月。",
                }, {
                    Name: " 第5届中国大学生软件测试大赛，",
                    Level: " <b style='color: red'>云南省一等奖</b>（个人赛，移动开发测试），",
                    Date: "2020年11月。",
                }, {
                    Name: " 第11届蓝桥杯大赛，",
                    Level: " <b style='color: red'>全国三等奖</b>（个人赛，Python大学组），",
                    Date: "2020年11月。",
                }, {
                    Name: " 第12届蓝桥杯大赛，",
                    Level: "云南省三等奖（个人赛，Python大学组），",
                    Date: "2021年4月。",
                }, {
                    Name: " 第12届中国大学生服务外包创新创业大赛，",
                    Level: "<b style='color: red'>中部区域赛一等奖</b>（<b style='color: red'>队长</b>，赛题A23，区块链相关），",
                    Date: "2021年5月。"
                }, {
                    Name: " 第7届中国大学生“互联网+”创新创业大赛，",
                    Level: "云南省铜奖（成员，初创组，软件测试相关），",
                    Date: "2021年7月。"
                }, {
                    Name: " 第7届中国大学生“互联网+”创新创业大赛，",
                    Level: "云南省铜奖（成员，初创组，区块链相关），",
                    Date: "2021年7月。"
                }, {
                    Name: " 第6届中国高校计算机大赛-网络技术挑战赛，",
                    Level: "西南赛区三等奖（<b style='color: red'>队长</b>，赛题A，区块链相关），",
                    Date: "2021年7月。"
                }, {
                    Name: " 第12届中国大学生服务外包创新创业大赛，",
                    Level: "<b style='color: red'>全国二等奖</b>（<b style='color: red'>队长</b>，赛题A23，区块链相关），",
                    Date: "2021年8月。"
                }, {
                    Name: " 第13届蓝桥杯大赛，",
                    Level: "云南省二等奖（个人赛，Python研究生组），",
                    Date: "2022年4月。",
                }, {
                    Name: " 第7届中国高校计算机大赛-网络技术挑战赛，",
                    Level: "西南赛区二等奖（<b style='color: red'>队长</b>，赛题A，区块链相关），",
                    Date: "2022年7月。"
                },]
            },
            PhD: {
                Title: "博士研究生",
                Content: [{
                    Name: " 第8届中国大学生“互联网+”创新创业大赛，",
                    Level: "云南省铜奖（<b style='color: red'>队长</b>），产业命题赛道，区块链相关），",
                    Date: "2022年8月。"
                }, {
                    Name: " 第7届中国高校计算机大赛-网络技术挑战赛，",
                    Level: "<b style='color: red'>全国三等奖</b>（<b style='color: red'>队长</b>，赛题A，区块链相关），",
                    Date: "2022年9月。"
                }, {
                    Name: " 第14届中国大学生服务外包创新创业大赛，",
                    Level: "中部区域赛三等奖（<b style='color: red'>队长</b>，赛题A24，区块链相关），",
                    Date: "2023年5月。"
                }, {
                    Name: " 第8届中国高校计算机大赛-网络技术挑战赛，",
                    Level: "西南赛区二等奖（<b style='color: red'>队长</b>，赛题A，区块链相关），",
                    Date: "2023年6月。"
                }, {
                    Name: " 第8届中国高校计算机大赛-网络技术挑战赛，",
                    Level: "<b style='color: red'>全国三等奖</b>（<b style='color: red'>队长</b>，赛题A，区块链相关），",
                    Date: "2023年9月。"
                }, {
                    Name: " 第15届中国大学生服务外包创新创业大赛，",
                    Level: "中部区域赛三等奖（<b style='color: red'>队长</b>，赛题A22，区块链相关），",
                    Date: "2024年5月。"
                }, {
                    Name: " 第9届中国高校计算机大赛-网络技术挑战赛，",
                    Level: "西南赛区二等奖（<b style='color: red'>队长</b>，赛题A，区块链相关），",
                    Date: "2024年6月。"
                }, {
                    Name: " 第9届中国高校计算机大赛-移动应用创新赛，",
                    Level: "西南赛区二等奖（成员，启迪赛道，区块链、计算机视觉相关），",
                    Date: "2024年6月。"
                }, {
                    Name: " 第18届iCAN大学生创新创业大赛，",
                    Level: "西南赛区二等奖（成员，区块链、计算机视觉相关），",
                    Date: "2024年10月。"
                },]
            },
            Tearcher: {
                Title: "指导教师",
                Content: []
            },
        },
        Funds: {
            Title: "科研项目和计划",
            Leader: {
                Title: "主持",
                Content: [{
                    Name: " 《基于证据链的高效联网收费稽查信誉机制研究》，",
                    Type: "云南省教育厅科学研究基金研究生项目，",
                    Funding: "2021Y018（0.5万元），",
                    Date: "2021年2月-2022年2月（已结题，优秀）。",
                }, {
                    Name: " 《区块链与云边协同赋能的电力监控系统复杂环境下的数据治理》，",
                    Type: "云南大学第十四届研究生科研创新项目，",
                    Funding: "KC-2222958（1万元），",
                    Date: "2022年11月-2024年5月（已结题，优秀）。",
                },
                ]
            },
            Hold: {
                Title: "入选",
                Content: [{
                    Name: " 首批《中国科协青年人才托举工程博士生专项计划》，",
                    Type: "托举学会：中国汽车工程学会，",
                    Funding: "4万元，",
                    Date: "2024年12月-2026年12月。",
                }
                ]
            },
            Member: {
                Title: "参与",
                Content: [{
                    Name: " 《基于组件划分的多层次软件运行过程挖掘方法》，",
                    Type: "云南大学第十二届研究生科研创新项目（重点项目），",
                    Funding: "2020Z71（1万元），",
                    Date: "2020年10月-2021年10月。",
                }, {
                    Name: " 《车联网深度动态信誉机制与边缘可信交易体系研究》，",
                    Type: "云南大学第二届专业学位研究生实践创新项目，",
                    Funding: "ZC-22221624（0.5万元），",
                    Date: "2023年2月-2024年2月。",
                }]
            }
        },
        Patents: {
            Title: "专利",
            First: {
                Title: "第一排名",
                Content: [{
                    Name: " 一种基于证据链框架的信誉ETC系统以及数据保护方法和基于信誉值的车辆行为管理方法，",
                    ID: "CN202110277565.4",
                    State: "（已授权）。"
                }]
            },
            Co: {
                Title: "其它排名",
                Content: [
                    {
                        Name: " 一种基于过程挖掘的临床路径优化方法，",
                        ID: "CN202011525241.X",
                        State: "（实质审查中）。"
                    }, {
                        Name: " 一种基于非负矩阵分解与动态时间规整算法的交通流缺失值填充方法，",
                        ID: "CN202011617854.6",
                        State: "（已授权）。"
                    }, {
                        Name: " 一种基于积分证明链的共享停车管理方法及系统，",
                        ID: "CN202110564049.X",
                        State: "（已授权）。"
                    }, {
                        Name: " 一种基于区块链的高速路费用确定方法及系统，",
                        ID: "CN202111187042.3",
                        State: "（实质审查中）。"
                    }, {
                        Name: " 联合语义解析和语义成分匹配的NL2SQL的方法，",
                        ID: "CN202211131620.X",
                        State: "（已授权）。"
                    }, {
                        Name: " 基于区块链的智能车辆数字取证系统、激励方法及设备，",
                        ID: "CN202310048785.9",
                        State: "（已授权）。"
                    }, {
                        Name: " 基于图对比学习的非法账户识别方法，",
                        ID: "CN202310129147.X",
                        State: "（实质审查中）。"
                    },
                    // {
                    //     Name: " 一种基于执行者过程树的双维度遗传过程挖掘方法，",
                    //     ID: "CN202011503109.9",
                    //     State: "（实质审查中）。"
                    // }
                ]
            }
        },
        CopyRights: {
            Title: "软件著作权",
            First: {
                Title: "第一排名",
                Content: [{
                    Name: " 个人博客系统V1.0，",
                    ID: "2020R11L387460。",
                }, {
                    Name: " 校园官网系统V1.0，",
                    ID: "2020R11L2617978。",
                }, {
                    Name: " 建水风土文化展示系统V1.0，",
                    ID: "2020R11L2594452。",
                }]
            },
            Co: {
                Title: "其它排名",
                Content: []
            }
        },
        Certificates: {
            Title: "专业技术和资格证书",
            Content: [
                {
                    Name: " 计算机技术与软件专业技术资格（水平）考试（软考）—软件设计师，",
                    Date: "2018。"
                },
                {
                    Name: " 大学英语四级，",
                    Date: "2018。"
                },
                {
                    Name: " 计算机技术与软件专业技术资格（水平）考试（软考）—软件评测师，",
                    Date: "2019。"
                }
            ]
        },
        Rewards: {
            Title: "奖励与荣誉",
            Undergraduate: {
                Title: "本科",
                Content: [
                    {
                        Name: " 昆明学院校级优秀学生干部奖学金，",
                        Date: "2016年10月。"
                    },
                    {
                        Name: " 昆明学院“技风行动”计算机课堂优秀讲师，",
                        Date: "2016年12月。"
                    },
                    {
                        Name: " 昆明学院世博车市奖学金，",
                        Date: "2017年4月。"
                    },
                    {
                        Name: " 昆明学院“技风行动”计算机课堂优秀讲师，",
                        Date: "2017年5月。"
                    },
                    {
                        Name: " 昆明学院校级三好学生二等奖学金，",
                        Date: "2017年10月。"
                    },
                    {
                        Name: " 昆明学院校级三好学生一等奖学金，",
                        Date: "2018年10月。"
                    },
                    {
                        Name: " <b style='color: red'>云南省省政府奖学金</b>，",
                        Date: "2018年10月。"
                    },
                    {
                        Name: " 昆明学院优秀毕业论文，",
                        Date: "2019年5月。"
                    },
                    {
                        Name: " 昆明学院优秀毕业生，",
                        Date: "2019年7月。"
                    },
                    {
                        Name: " <b style='color: red'>云南省优秀毕业生</b>，",
                        Date: "2019年7月。"
                    },]
            },
            Graduate: {
                Title: "硕士研究生",
                Content: [
                    {
                        Name: " 云南大学一等学业奖学金，",
                        Date: "2020年10月。"
                    },
                    {
                        Name: " 云南大学二等学业奖学金，",
                        Date: "2021年10月。"
                    },
                    {
                        Name: " <b style='color: red'>国家奖学金</b>，",
                        Date: "2021年10月。"
                    },
                    {
                        Name: " 云南大学优秀毕业生，",
                        Date: "2022年3月。"
                    },
                    {
                        Name: " <b style='color: red'>云南省优秀毕业生</b>，",
                        Date: "2022年3月。"
                    },]
            },
            PhD: {
                Title: "博士研究生",
                Content: [
                    {
                        Name: " 云南大学二等学业奖学金，",
                        Date: "2022年10月。"
                    }, {
                        Name: " 云南大学一等学业奖学金，",
                        Date: "2023年10月。"
                    }, {
                        Name: " 云南大学一等学业奖学金，",
                        Date: "2024年10月。"
                    }, {
                        Name: " 云南大学熊庆来奖学金，",
                        Date: "2024年12月。"
                    }, {
                        Name: " 云南大学一等学业奖学金，",
                        Date: "2025年10月。"
                    },
                    {
                        Name: " <b style='color: red'>国家奖学金</b>，",
                        Date: "2025年10月。"
                    }]
            },
            Teacher: {
                Title: "教师",
                Content: []
            },
        },
        Review: {
            Title: "学术服务",
            ID: "序号",
            Publication: {
                ID: "序号",
                Title: "受邀担任审稿人（数据以最新一次接受审稿时为准）",
                Journal: "期刊（缩写）",
                Conference:"会议名（缩写）",
                Date: "审稿时间（次数）",
                Address:"来源（出版商）",
                // Area: "中科院分区",
                // CCF: "CCF分级",
                // IF: "影响因子",
                // Duration: "给定时间（天）",
                // Editor: [],
                Review: {
                    Conference: [{
                        Name: " IEEE International Conference on Blockchain Technology and Information Security (ICBCTIS)<sup>3th</sup>",
                        Date: "2023（1）",
                        Area: "",
                        CCF: "",
                        IF: "",
                        Duration: 14,
                        Address:"IEEE"
                    },],
                    Springer: [{
                        Name: " The Journal of Supercomputing",
                        Date: "2024（1）",
                        Area: "4",
                        CCF: "C",
                        IF: 2.7,
                        Duration: 21
                    }, {
                        Name: " Peer-to-Peer Networking and Applications (PPNA)",
                        Date: "2024（1），2025（2）",
                        Area: "4",
                        CCF: "C",
                        IF: 2.6,
                        Duration: 21
                    }, {
                        Name: " Scientific Reports",
                        Date: "2024（1）",
                        Area: "4",
                        CCF: "",
                        IF: 2.7,
                        Duration: 14
                    }, {
                        Name: " Discover Artificial Intelligence",
                        Date: "2025（2）",
                        Area: "",
                        CCF: "",
                        IF: "",
                        Duration: 14
                    },],
                    IEEE: [{
                        Name: " IEEE Transactions on Service Computing (TSC)",
                        Date: "2025（1）",
                        Area: "2",
                        CCF: "A",
                        IF: 5.5,
                        Duration: 40
                    }, {
                        Name: " IEEE Transactions on Network and Service Management (TNSM)",
                        Date: "2025（1）",
                        Area: "2",
                        CCF: "C",
                        IF: 5.4,
                        Duration: 60
                    }, {
                        Name: " IEEE Internet of Things Journal (IoTJ)",
                        Date: "2025（1），2026（1）",
                        Area: "2",
                        CCF: "C",
                        IF: "",
                        Duration: 14
                    },],
                    Elsevier: [{
                        Name: " Cluster Computing",
                        Date: "2024（1）",
                        Area: "3",
                        CCF: "",
                        IF: 3.6,
                        Duration: 21
                    },],
                }
            },
        },
    },

    Link: {
        Title: "友链",
        Content: "<p>添加友链请按以下格式留言哦。</p><p>名称：FFC的小站</p><p>地址：https://www.loveffc.cn</p><p>头像（选填，不填则为默认头像哦）：<a href='https://www.loveffc.cn:8080/img/HeadImage2.99b5bf64.jpg' style='float: none;color: limegreen;'>https://www.loveffc.cn:8080/img/HeadImage2.99b5bf64.jpg</a></p>",
    }
}